<template>
  <div class="px-1 mb-2">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <h4 class="mt-3">
      {{ $getVisibleNames("manual.matriz_3", false, "Matriz 3") }}:
      {{ $t("matrix3.matrix3View.tributationOf") }}
      {{ $getVisibleNames("mesh.egressprofilematter", true, "Asignaturas") }}
      {{ $t("matrix3.matrix3View.to") }}
      {{ $getVisibleNames("mesh.egressprofile", false, "Perfil de Egreso") }}
      <!-- Perfil de Egreso -->
    </h4>

    <!-- <div class="d-flex justify-content-center">
      <div class="w-25">
        <b-form-group
          label="Ciclo"
          label-cols="0"
          label-cols-sm="2"
          class="text-center wa"
        >
          <b-form-select
            :options="cycles"
            v-model="cycle_id"
            text-field="name"
            value-field="id"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </div>
    </div> -->
    <template>
      <!-- v-if="cycle_id" -->
      <Matrix3 :egress_profile_id="egress_profile_id"></Matrix3>
      <!-- :cycle_id="cycle_id" -->
      <div class="matrix3-report-container mt-3">
        <div
          v-for="competenceType in competenceTypes"
          v-bind:key="competenceType.id"
        >
          <div v-if="reportCompetences(competenceType.id).length">
            <div class="competences">
              <strong>{{ competenceType.name.toUpperCase() }}</strong>
            </div>
            <table class="competences-table">
              <thead class="competence-header">
                <th class="competence-caption-title">
                  {{ $t("matrix3.matrix3View.definition") }}
                </th>
                <th
                  class="competence-caption-title"
                  v-if="
                    egressProfile
                      ? egressProfileCycleId.length > 0
                        ? true
                        : false
                      : false
                  "
                >
                  {{
                    egressProfileCycleId.length > 1
                      ? $getVisibleNames(
                          "mesh.cycle",
                          true,
                          "Ciclos Formativos"
                        )
                      : $getVisibleNames("mesh.cycle", false, "Ciclo Formativo")
                  }}
                </th>
                <th
                  class="competence-caption-title"
                  v-if="profileCompetencesMention.length > 0 ? true : false"
                >
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilecompetencemention",
                      profileCompetencesMention.length > 1,
                      "Mención"
                    )
                  }}
                </th>
                <th
                  v-if="showsRealizationScopes"
                  class="amount-courses realization-scopes-column"
                >
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilerealizationscope",
                      true,
                      "Ámbitos de realización"
                    )
                  }}
                </th>
                <th class="amount-courses pr-3">
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      true,
                      "Asignaturas"
                    )
                  }}
                </th>
                <!-- <th class="amount">Cantidad</th> -->
                <th v-if="can_update && allows_crud"></th>
              </thead>
              <tbody>
                <tr
                  v-for="item in reportCompetences(competenceType.id)"
                  v-bind:key="item.id"
                  class="competences-row"
                >
                  <td class="competence-caption">
                    <div class="d-flex">
                      <SentenceContainer :Sentence="item">
                        <template #order>
                          <span class="mr-1">
                            {{
                              item.profile_cycle
                                ? item.profile_cycle.order + "." + item.order
                                : item.order + "."
                            }}<span
                              v-if="
                                item.sub_order > 0 &&
                                institution &&
                                institution.show_competence_sub_order
                              "
                              >.{{ item.sub_order }}</span
                            >
                          </span>
                        </template>
                      </SentenceContainer>
                      <!-- {{ item.full_sentence }} -->
                    </div>
                  </td>
                  <td
                    class="competence-caption"
                    v-if="
                      egressProfile
                        ? egressProfileCycleId.length > 0
                          ? true
                          : false
                        : false
                    "
                  >
                    {{ cycleName(item.cycle) }}
                  </td>
                  <td
                    class="competence-caption"
                    v-if="profileCompetencesMention.length > 0 ? true : false"
                  >
                    {{ mentionsName(item) }}
                  </td>
                  <!-- Por número, como en la Matriz 3: el detalle va en el tooltip y en el
                       resumen de ámbitos -->
                  <td v-if="showsRealizationScopes" class="amount-courses">
                    <span
                      v-for="realization_scope in competenceRealizationScopes(
                        item
                      )"
                      :key="`competence-${item.id}-realization-scope-${realization_scope.id}`"
                      v-b-tooltip.v-secondary.noninteractive="
                        realization_scope.tooltip
                      "
                      class="realization-scope-number"
                      >{{ realization_scope.number }}</span
                    >
                  </td>
                  <td class="amount-courses">
                    <div class="competence-matters-container">
                      <b-button
                        size="sm"
                        v-b-tooltip.v-secondary.hover="
                          item.courses.length > 0
                            ? $t('matrix3.matrix3View.viewDetails')
                            : ''
                        "
                        class="popover-btn"
                        @click="
                          $bvModal.show(`competence-matters-modal-${item.id}`)
                        "
                      >
                        <b-badge variant="secondary"
                          >{{ item.cantidad }}<span class="sr-only"></span
                        ></b-badge>
                      </b-button>
                      <b-modal
                        v-if="item.courses.length > 0"
                        :id="`competence-matters-modal-${item.id}`"
                        size="lg"
                        hide-footer
                      >
                        <template #modal-title>
                          <h6>
                            <span class="m-1 text-justify d-flex">
                              <SentenceContainer :Sentence="item">
                                <template #order>
                                  <span class="mr-1">
                                    {{
                                      item.profile_cycle
                                        ? item.profile_cycle.order +
                                          "." +
                                          item.order
                                        : item.order + "."
                                    }}<span
                                      v-if="
                                        item.sub_order > 0 &&
                                        institution &&
                                        institution.show_competence_sub_order
                                      "
                                      >.{{ item.sub_order }}</span
                                    >
                                  </span>
                                </template>
                              </SentenceContainer>
                              <!-- {{ item.full_sentence }} -->
                            </span>
                          </h6>
                        </template>
                        <b-table-simple responsive small bordered>
                          <b-thead>
                            <b-tr>
                              <b-th class="th-class">{{
                                $t("matrix3.matrix3View.planLevel")
                              }}</b-th>
                              <b-th class="th-class">{{
                                $getVisibleNames(
                                  "mesh.egressprofilematter",
                                  true,
                                  "Asignaturas"
                                )
                              }}</b-th>
                              <b-th class="th-class">
                                {{
                                  $getVisibleNames(
                                    "manual.credits",
                                    true,
                                    "Créditos SCT Totales"
                                  )
                                }}
                              </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="egress_profile_matter in egressProfileMatterList.filter(
                                (x) => item.courses.includes(x.id)
                              )"
                              :key="egress_profile_matter.id + '-' + item.id"
                            >
                              <b-td class="text-center">{{
                                egress_profile_matter.plan_level
                              }}</b-td>
                              <b-td>
                                <b-link
                                  :to="{
                                    name: 'MatterProgramView',
                                    params: {
                                      matter_id: egress_profile_matter.id,
                                    },
                                  }"
                                  v-b-tooltip.v-secondary="
                                    `${$t(
                                      'matrix3.matrix3View.goTo'
                                    )} ${$getVisibleNames(
                                      'manual.matter_program',
                                      false,
                                      'Programa de Asignatura'
                                    )}`
                                  "
                                >
                                  {{
                                    getMatterName(
                                      egress_profile_matter.matter
                                    ).toUpperCase()
                                  }}
                                </b-link>
                              </b-td>
                              <b-td class="text-center">
                                {{
                                  egress_profile_matter.use_matter_values
                                    ? (
                                        matters.find(
                                          (x) =>
                                            x.id == egress_profile_matter.matter
                                        ) || {}
                                      ).credits || 0
                                    : egress_profile_matter.credits
                                }}
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-modal>
                    </div>
                  </td>
                  <td v-if="can_update && allows_crud">
                    <ButtonSmall
                      tabindex="-1"
                      :tooltip_text="`${$t(
                        'reusable.common.edit'
                      )} ${$getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      )}`"
                      :click_button="
                        () => {
                          initializeSelectedSubjects(item);
                          $bvModal.show(
                            `edit-egressprofilematter-modal-${item.id}`
                          );
                        }
                      "
                      :icon="'square'"
                    ></ButtonSmall>
                    <!-- Modal para editar asignaturas de la competencia -->
                    <b-modal
                      :id="`edit-egressprofilematter-modal-${item.id}`"
                      :title="
                        $t('matrix3.matrix3View.editSubjectsOfCompetence')
                      "
                      size="lg"
                      @ok="saveCompetenceSubjects(item)"
                      @hide="clearModalSelectionData(item.id)"
                      :ok-title="$t('reusable.common.save')"
                      :cancel-title="$t('reusable.common.cancel')"
                    >
                      <div class="mb-3">
                        <strong>{{
                          $t("matrix3.matrix3View.competence")
                        }}</strong>
                        <div class="mt-2">
                          <SentenceContainer :Sentence="item">
                            <template #order>
                              <span class="mr-1">
                                {{
                                  item.profile_cycle
                                    ? item.profile_cycle.order +
                                      "." +
                                      item.order
                                    : item.order + "."
                                }}<span
                                  v-if="
                                    item.sub_order > 0 &&
                                    institution &&
                                    institution.show_competence_sub_order
                                  "
                                  >.{{ item.sub_order }}</span
                                >
                              </span>
                            </template>
                          </SentenceContainer>
                        </div>
                      </div>

                      <b-form-group
                        :label="
                          $getVisibleNames(
                            'mesh.egressprofilematter',
                            true,
                            'Asignaturas'
                          )
                        "
                        label-for="competence-subjects"
                      >
                        <v-select
                          id="competence-subjects"
                          v-model="selectedSubjects[item.id]"
                          :options="
                            availableSubjectsForCompetence(item.id, item.cycle)
                          "
                          :reduce="(option) => option.value"
                          :selectable="
                            (option) =>
                              !option.disabled &&
                              !selectedSubjects[item.id].includes(option.value)
                          "
                          :placeholder="`${String(
                            $t('reusable.common.select') +
                              ' ' +
                              $getVisibleNames(
                                'mesh.egressprofilematter',
                                true,
                                'Asignaturas'
                              )
                          )}`"
                          :dropdown-should-open="
                            (vueSelect) =>
                              dropdownShouldOpen(vueSelect, item.id, item.cycle)
                          "
                          multiple
                          label="text"
                          track-by="value"
                          size="sm"
                        >
                          <template
                            v-slot:selected-option-container="{
                              option,
                              deselect,
                              disabled,
                            }"
                          >
                            <span class="vs__selected">
                              <span :class="{ 'text-muted': option.disabled }">
                                {{ option.text }}
                                <small
                                  v-if="option.disabled"
                                  class="text-danger"
                                >
                                  {{ $t("matrix3.matrix3View.closed") }}
                                </small>
                              </span>
                              <button
                                v-if="!disabled && !option.disabled"
                                :disabled="disabled"
                                type="button"
                                class="vs__deselect"
                                :title="`${option.text}`"
                                :aria-label="`${option.text}`"
                                @mousedown.prevent.stop="deselect(option)"
                              >
                                <b-icon-x variant="danger"></b-icon-x>
                              </button>
                            </span>
                          </template>
                          <template v-slot:option="option">
                            <span :class="{ 'text-muted': option.disabled }">
                              {{ option.text }}
                              <small v-if="option.disabled" class="text-danger">
                                {{ $t("matrix3.matrix3View.closed") }}
                              </small>
                            </span>
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{ $t("reusable.common.noOptions") }}
                              <em>{{ search }}</em
                              >.
                            </template>
                          </template>
                        </v-select>
                        <small class="text-muted">
                          {{
                            $t(
                              "matrix3.matrix3View.selectSubjectsThatContribute",
                              {
                                subjects: $getVisibleNames(
                                  "mesh.egressprofilematter",
                                  true,
                                  "Asignaturas"
                                ),
                                competence: $getVisibleNames(
                                  "mesh.competence",
                                  false,
                                  "competencia"
                                ),
                              }
                            )
                          }}
                        </small>
                      </b-form-group>
                    </b-modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <div v-if="reportCompetences(null).length">
            <div class="competences">
              <strong>{{
                $getVisibleNames(
                  "mesh.competence",
                  true,
                  "Competencias"
                ).toUpperCase()
              }}</strong>
            </div>
            <table class="competences-table">
              <thead class="competence-header">
                <th class="competence-caption-title">
                  {{ $t("matrix3.matrix3View.definition") }}
                </th>
                <th
                  class="competence-caption-title"
                  v-if="
                    egressProfile
                      ? egressProfileCycleId.length > 0
                        ? true
                        : false
                      : false
                  "
                >
                  {{
                    egressProfileCycleId.length > 1
                      ? $getVisibleNames(
                          "mesh.cycle",
                          true,
                          "Ciclos Formativos"
                        )
                      : $getVisibleNames("mesh.cycle", false, "Ciclo Formativo")
                  }}
                </th>
                <th
                  class="competence-caption-title"
                  v-if="profileCompetencesMention.length > 0 ? true : false"
                >
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilecompetencemention",
                      profileCompetencesMention.length > 1,
                      "Mención"
                    )
                  }}
                </th>
                <th
                  v-if="showsRealizationScopes"
                  class="amount-courses realization-scopes-column"
                >
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilerealizationscope",
                      true,
                      "Ámbitos de realización"
                    )
                  }}
                </th>
                <th class="amount-courses pr-3">
                  {{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      true,
                      "Asignaturas"
                    )
                  }}
                </th>
                <!-- <th class="amount">Cantidad</th> -->
                <th v-if="can_update && allows_crud"></th>
              </thead>
              <tbody>
                <tr
                  v-for="item in reportCompetences(null)"
                  v-bind:key="item.id"
                  class="competences-row"
                >
                  <td class="competence-caption">
                    <div class="d-flex">
                      <SentenceContainer :Sentence="item">
                        <template #order>
                          <span class="mr-1">
                            {{
                              item.profile_cycle
                                ? item.order + "." + item.profile_cycle.order
                                : item.order + "."
                            }}<span
                              v-if="
                                item.sub_order > 0 &&
                                institution &&
                                institution.show_competence_sub_order
                              "
                              >.{{ item.sub_order }}</span
                            >
                          </span>
                        </template>
                      </SentenceContainer>
                      <!-- {{ item.full_sentence }} -->
                    </div>
                  </td>
                  <td
                    class="competence-caption"
                    v-if="
                      egressProfile
                        ? egressProfileCycleId.length > 0
                          ? true
                          : false
                        : false
                    "
                  >
                    {{ cycleName(item.cycle) }}
                  </td>
                  <td
                    class="competence-caption"
                    v-if="profileCompetencesMention.length > 0 ? true : false"
                  >
                    {{ mentionsName(item) }}
                  </td>
                  <!-- Por número, como en la Matriz 3: el detalle va en el tooltip y en el
                       resumen de ámbitos -->
                  <td v-if="showsRealizationScopes" class="amount-courses">
                    <span
                      v-for="realization_scope in competenceRealizationScopes(
                        item
                      )"
                      :key="`competence-${item.id}-realization-scope-${realization_scope.id}`"
                      v-b-tooltip.v-secondary.noninteractive="
                        realization_scope.tooltip
                      "
                      class="realization-scope-number"
                      >{{ realization_scope.number }}</span
                    >
                  </td>
                  <td class="amount-courses">
                    <div class="competence-matters-container">
                      <!-- :id="`popover-button-variant-${item.id}`" -->
                      <b-button
                        size="sm"
                        v-b-tooltip.v-secondary.hover="
                          item.courses.length > 0
                            ? $t('matrix3.matrix3View.viewDetails')
                            : ''
                        "
                        class="popover-btn"
                        @click="
                          $bvModal.show(`competence-matters-modal-2-${item.id}`)
                        "
                      >
                        <b-badge variant="secondary"
                          >{{ item.cantidad }}<span class="sr-only"></span
                        ></b-badge>
                      </b-button>
                      <b-modal
                        v-if="item.courses.length > 0"
                        :id="`competence-matters-modal-2-${item.id}`"
                        size="lg"
                        hide-footer
                      >
                        <template #modal-title>
                          <h6>
                            <span class="m-1 text-justify d-flex">
                              <SentenceContainer :Sentence="item">
                                <template #order>
                                  <span class="mr-1">
                                    {{
                                      item.profile_cycle
                                        ? item.order +
                                          "." +
                                          item.profile_cycle.order
                                        : item.order + "."
                                    }}<span
                                      v-if="
                                        item.sub_order > 0 &&
                                        institution &&
                                        institution.show_competence_sub_order
                                      "
                                      >.{{ item.sub_order }}</span
                                    >
                                  </span>
                                </template>
                              </SentenceContainer>
                              <!-- {{ item.full_sentence }} -->
                            </span>
                          </h6>
                        </template>
                        <b-table-simple responsive small bordered>
                          <b-thead>
                            <b-tr>
                              <b-th class="th-class">{{
                                $t("matrix3.matrix3View.planLevel")
                              }}</b-th>
                              <b-th class="th-class">{{
                                $getVisibleNames(
                                  "mesh.egressprofilematter",
                                  true,
                                  "Asignaturas"
                                )
                              }}</b-th>
                              <b-th class="th-class">
                                {{
                                  $getVisibleNames(
                                    "manual.credits",
                                    true,
                                    "Créditos SCT Totales"
                                  )
                                }}
                              </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="egress_profile_matter in egressProfileMatterList.filter(
                                (x) => item.courses.includes(x.id)
                              )"
                              :key="egress_profile_matter.id + '-' + item.id"
                            >
                              <b-td class="text-center">{{
                                egress_profile_matter.plan_level
                              }}</b-td>
                              <b-td>
                                <b-link
                                  :to="{
                                    name: 'MatterProgramView',
                                    params: {
                                      matter_id: egress_profile_matter.id,
                                    },
                                  }"
                                  v-b-tooltip.v-secondary="
                                    `${$t(
                                      'matrix3.matrix3View.goTo'
                                    )} ${$getVisibleNames(
                                      'manual.matter_program',
                                      false,
                                      'Programa de Asignatura'
                                    )}`
                                  "
                                >
                                  {{
                                    getMatterName(
                                      egress_profile_matter.matter
                                    ).toUpperCase()
                                  }}
                                </b-link>
                              </b-td>
                              <b-td class="text-center">
                                {{
                                  egress_profile_matter.use_matter_values
                                    ? (
                                        matters.find(
                                          (x) =>
                                            x.id == egress_profile_matter.matter
                                        ) || {}
                                      ).credits || 0
                                    : egress_profile_matter.credits
                                }}
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </b-modal>
                    </div>
                  </td>
                  <td v-if="can_update && allows_crud">
                    <ButtonSmall
                      tabindex="-1"
                      :tooltip_text="`${$t(
                        'reusable.common.edit'
                      )} ${$getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      )}`"
                      :click_button="
                        () => {
                          initializeSelectedSubjects(item);
                          $bvModal.show(
                            `edit-egressprofilematter-modal-${item.id}`
                          );
                        }
                      "
                      :icon="'square'"
                      :class="`mr-1`"
                    ></ButtonSmall>
                    <!-- Modal para editar asignaturas de la competencia -->
                    <b-modal
                      :id="`edit-egressprofilematter-modal-${item.id}`"
                      :title="
                        $t('matrix3.matrix3View.editSubjectsOfCompetence')
                      "
                      size="lg"
                      @ok="saveCompetenceSubjects(item)"
                      @hide="clearModalSelectionData(item.id)"
                      :ok-title="$t('reusable.common.save')"
                      :cancel-title="$t('reusable.common.cancel')"
                    >
                      <div class="mb-3">
                        <strong>{{
                          $t("matrix3.matrix3View.competence")
                        }}</strong>
                        <div class="mt-2">
                          <SentenceContainer :Sentence="item">
                            <template #order>
                              <span class="mr-1">
                                {{
                                  item.profile_cycle
                                    ? item.order +
                                      "." +
                                      item.profile_cycle.order
                                    : item.order + "."
                                }}<span
                                  v-if="
                                    item.sub_order > 0 &&
                                    institution &&
                                    institution.show_competence_sub_order
                                  "
                                  >.{{ item.sub_order }}</span
                                >
                              </span>
                            </template>
                          </SentenceContainer>
                        </div>
                      </div>

                      <b-form-group
                        :label="
                          $getVisibleNames(
                            'mesh.egressprofilematter',
                            true,
                            'Asignaturas'
                          )
                        "
                        label-for="competence-subjects"
                      >
                        <v-select
                          id="competence-subjects"
                          v-model="selectedSubjects[item.id]"
                          :options="
                            availableSubjectsForCompetence(item.id, item.cycle)
                          "
                          :reduce="(option) => option.value"
                          :selectable="
                            (option) =>
                              !option.disabled &&
                              !selectedSubjects[item.id].includes(option.value)
                          "
                          :placeholder="`${String(
                            $t('reusable.common.select') +
                              ' ' +
                              $getVisibleNames(
                                'mesh.egressprofilematter',
                                true,
                                'Asignaturas'
                              )
                          )}`"
                          :dropdown-should-open="
                            (vueSelect) =>
                              dropdownShouldOpen(vueSelect, item.id, item.cycle)
                          "
                          multiple
                          label="text"
                          track-by="value"
                          size="sm"
                        >
                          <template
                            v-slot:selected-option-container="{
                              option,
                              deselect,
                              disabled,
                            }"
                          >
                            <span class="vs__selected">
                              <span :class="{ 'text-muted': option.disabled }">
                                {{ option.text }}
                                <small
                                  v-if="option.disabled"
                                  class="text-danger"
                                >
                                  {{ $t("matrix3.matrix3View.closed") }}
                                </small>
                              </span>
                              <button
                                v-if="!disabled && !option.disabled"
                                :disabled="disabled"
                                type="button"
                                class="vs__deselect"
                                :title="`${option.text}`"
                                :aria-label="`${option.text}`"
                                @mousedown.prevent.stop="deselect(option)"
                              >
                                <b-icon-x variant="danger"></b-icon-x>
                              </button>
                            </span>
                          </template>
                          <template v-slot:option="option">
                            <span :class="{ 'text-muted': option.disabled }">
                              {{ option.text }}
                              <small v-if="option.disabled" class="text-danger">
                                {{ $t("matrix3.matrix3View.closed") }}
                              </small>
                            </span>
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{ $t("reusable.common.noOptions") }}
                              <em>{{ search }}</em
                              >.
                            </template>
                          </template>
                        </v-select>
                        <small class="text-muted">
                          {{
                            $t(
                              "matrix3.matrix3View.selectSubjectsThatContribute",
                              {
                                subjects: $getVisibleNames(
                                  "mesh.egressprofilematter",
                                  true,
                                  "Asignaturas"
                                ),
                                competence: $getVisibleNames(
                                  "mesh.competence",
                                  false,
                                  "competencia"
                                ),
                              }
                            )
                          }}
                        </small>
                      </b-form-group>
                    </b-modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <CognitiveColorTable style="width: 35em"></CognitiveColorTable> -->
      </div>
    </template>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
import {
  scopeNumbers,
  scopeTooltip,
  scopesOfEgressProfile,
} from "@/utils/realizationScopes";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "Matrix3View",
  components: {
    vSelect,
    Matrix3: () => import("./Matrix3"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
    // CognitiveColorTable: () =>
    //   import("@/components/reusable/CognitiveColorTable"),
  },
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
      // cycle_id: null,
      printing: false,
      institution_id: this.$store.getters.getInstitutionId,
      isActive: false,
      selectedSubjects: {}, // Para almacenar las asignaturas seleccionadas por competencia
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      cycles: names.CYCLES,
      formationAreas: names.FORMATION_AREAS,
      matters: names.MATTERS,
      competenceTypes: names.COMPETENCE_TYPES,
      competences: names.COMPETENCES,
      profile_cycles: names.PROFILE_CYCLES,
      profile_competences: names.PROFILE_COMPETENCES,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      courses_wrapper: names.COURSES_WRAPPER,
      profile_competences_mention: names.PROFILE_COMPETENCES_MENTION,
      realization_scopes: names.REALIZATION_SCOPES,
    }),
    // Ámbitos de realización del perfil con su número (los carga Matrix3). La columna solo
    // aparece si la institución los usa y el perfil tiene.
    profileRealizationScopes() {
      if (!this.$usesRealizationScopes(this.institution)) return [];
      const profile_scopes = scopesOfEgressProfile(
        this.realization_scopes,
        this.egress_profile_id
      );
      const numbers = scopeNumbers(profile_scopes);
      return profile_scopes.map((x) => ({
        ...x,
        number: numbers[x.id],
        tooltip: scopeTooltip(x),
      }));
    },
    showsRealizationScopes() {
      return this.profileRealizationScopes.length > 0;
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames("manual.matriz_3", false, "Matriz 3"),
          dropdownOptions: [
            "showEgressProfile",
            "showMatrix1",
            "showMatrix2",
            "showMatrix4",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
    egressProfile() {
      if (!this.egress_profile_id) return [];
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission("mesh.career", "change", this.career.id))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
            this.$hasObjectPermission("mesh.career", "delete", this.career.id))
        );
      }
      return false;
    },
    allows_crud() {
      if (
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions(
          "mesh.change_egressprofile"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
    coursesWrapperList() {
      return this.courses_wrapper.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    wrapperMatterIds() {
      let list = [];
      this.coursesWrapperList.forEach((x) => {
        list = list.concat(x.egress_profile_matters);
      });
      return [...new Set(list)];
    },
    egressProfileMatterList() {
      if (!this.egress_profile_id) return [];
      return this.egress_profiles_matters.filter(
        (x) =>
          x.egress_profile == this.egress_profile_id &&
          !this.wrapperMatterIds.includes(x.id)
      );
    },
    egressProfileCycleId() {
      if (!this.egress_profile_id) return [];
      let list = [];
      this.profile_cycles.forEach((x) => {
        if (x.egress_profile == this.egress_profile_id) list.push(x.cycle);
      });
      return list;
    },
    profileCompetencesMention() {
      return this.profile_competences_mention
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
  },
  methods: {
    dropdownShouldOpen(VueSelect, competence_id, cycle_id = null) {
      if (
        this.availableSubjectsForCompetence(competence_id, cycle_id).length > 0
      ) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    cycleName(cycle_id) {
      if (!cycle_id && !this.egress_profile_id)
        return this.$t("reusable.common.notApplicable");
      let cycle = this.cycles.find(
        (x) =>
          x.id == cycle_id && x.egress_profiles.includes(this.egress_profile_id)
      );
      return cycle ? cycle.name : this.$t("reusable.common.notApplicable");
    },
    mentionsName(profile_competence) {
      const mentions = this.profile_competences_mention
        .filter(
          (x) =>
            x.egress_profile == profile_competence.egress_profile &&
            x.egress_profile_competences.includes(
              profile_competence.profile_competence_id
            )
        )
        .map((x) => x.name);
      if (mentions.length > 1) return mentions.join(", ");
      else if (mentions.length == 1) return mentions[0];
      else return this.$t("reusable.common.common");
    },
    getMatterName(id) {
      const matter = this.matters.find((x) => x.id == id);
      return matter ? matter.name : "";
    },
    competenceRealizationScopes(competence) {
      return this.profileRealizationScopes.filter((x) =>
        competence.realization_scopes.includes(x.id)
      );
    },
    reportCompetences(competence_type_id) {
      let report = [];
      // !this.cycle_id ||
      if (!this.egress_profile_id) return [];
      let list_competences = [];
      let list = this.profile_competences.filter(
        (x) =>
          //  x.cycle == this.cycle_id &&
          x.egress_profile == this.egress_profile_id
      );

      list.forEach((element) => {
        let competence = this.competences.find(
          (x) => x.id == element.competence && x.type == competence_type_id
        );
        if (competence) {
          list_competences.push({
            id: competence.id,
            type: competence.type,
            full_sentence: competence.full_sentence,
            cycle: element.cycle,
            order: element.order,
            sub_order: element.sub_order,
            egress_profile: element.egress_profile,
            profile_competence_id: element.id,
            realization_scopes: element.realization_scopes || [],
            action: competence.action,
            content: competence.content,
            condition: competence.condition,
            verb: competence.verb,
            // name: competence.name,
          });
        }
      });
      let listmatter = this.egressProfileMatterList;
      // .filter(
      //   (x) =>
      //     // x.cycle == this.cycle_id &&
      //     x.egress_profile == this.egress_profile_id
      // );
      if (list_competences && listmatter) {
        list_competences.forEach((element) => {
          let contador = 0;
          let courses = [];
          listmatter.forEach((matter) => {
            if (
              matter.competences.find((x) => x == element.id) &&
              element.type == competence_type_id
            ) {
              contador += 1;
              courses.push(matter.id);
            }
          });
          let get_cycle = null;
          let profile_cycle_order = 0;
          this.profile_cycles.forEach((profile_cycle) => {
            if (profile_cycle.cycle == element.cycle) {
              get_cycle = profile_cycle;
              profile_cycle_order = profile_cycle.order;
            }
          });
          report.push({
            id: element.id,
            full_sentence: element.full_sentence,
            action: element.action,
            content: element.content,
            condition: element.condition,
            verb: element.verb,
            cantidad: contador,
            courses: courses,
            cycle: element.cycle,
            order: element.order,
            sub_order: element.sub_order,
            profile_cycle: get_cycle,
            profile_cycle_order: profile_cycle_order,
            egress_profile: element.egress_profile,
            profile_competence_id: element.profile_competence_id,
            realization_scopes: element.realization_scopes,
          });
        });
      }
      // if (list && listmatter) {
      //   list.forEach((element) => {
      //     let contador = 0;
      //     listmatter.forEach((matter) => {
      //       if (
      //         matter.competences.find((x) => x == element.id) &&
      //         element.type == competence_type_id
      //       ) {
      //         contador += 1;
      //       }
      //     });
      //     report.push({
      //       id: element.id,
      //       name: element.sentence,
      //       cantidad: contador,
      //     });
      //   });
      // }
      report.sort(function (a, b) {
        if (a.profile_cycle_order > b.profile_cycle_order) return 1;
        if (a.profile_cycle_order < b.profile_cycle_order) return -1;
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        if (a.sub_order > b.sub_order) return 1;
        if (a.sub_order < b.sub_order) return -1;
        return 0;
      });
      return report;
    },
    // redirectToMatterProgram(id) {
    //   let route_data = this.$router.resolve({
    //     name: "MatterProgramView",
    //     params: {
    //       matter_id: id,
    //     },
    //   });
    //   window.open(route_data.href, "_blank");
    // },
    availableSubjectsForCompetence(competence_id, cycle_id = null) {
      // Si el ciclo es null, mostrar todas las asignaturas
      if (cycle_id === null) {
        return this.egressProfileMatterList.map((matter) => ({
          value: matter.id,
          text: `${matter.plan_level} - ${this.getMatterName(matter.matter)}`,
          disabled: matter.is_closed || false,
        }));
      }

      // Si no hay ciclos en el perfil o filter_competence_in_matrix_2 es false, mostrar todas las asignaturas
      if (
        this.egressProfileCycleId.length === 0 ||
        (this.institution &&
          this.institution.filter_competence_in_matrix_2 === false)
      ) {
        return this.egressProfileMatterList.map((matter) => ({
          value: matter.id,
          text: this.getMatterName(matter.matter),
          disabled: matter.is_closed || false,
        }));
      }

      // Buscar el ciclo para obtener init_semester y end_semester
      const cycle = this.cycles.find((c) => c.id === cycle_id);

      if (!cycle) {
        return this.egressProfileMatterList.map((matter) => ({
          value: matter.id,
          text: this.getMatterName(matter.matter),
          disabled: matter.is_closed || false,
        }));
      }

      // Filtrar asignaturas cuyo plan_level esté dentro del rango del ciclo
      // O que ya tengan la competencia asignada (para poder quitarla)
      return this.egressProfileMatterList
        .filter((matter) => {
          const planLevel = parseFloat(matter.plan_level);
          const isInCycleRange =
            planLevel >= cycle.init_semester && planLevel <= cycle.end_semester;
          const hasCompetence = matter.competences.includes(competence_id);

          return isInCycleRange || hasCompetence;
        })
        .map((matter) => ({
          value: matter.id,
          text: this.getMatterName(matter.matter),
          disabled: matter.is_closed || false,
        }));
    },
    initializeSelectedSubjects(competence) {
      // Inicializa las asignaturas seleccionadas para una competencia usando las asignaturas actuales
      this.$set(
        this.selectedSubjects,
        competence.id,
        this.mattersInCompetence(competence.id)
      );
    },
    mattersInCompetence(competence_id) {
      return this.egressProfileMatterList
        .filter((x) => x.competences.includes(competence_id))
        .map((x) => x.id);
    },
    saveCompetenceSubjects(competence) {
      const currentSubjects = this.mattersInCompetence(competence.id);
      const selectedSubjects = this.selectedSubjects[competence.id] || [];

      // Asignaturas que se van a agregar (están en selectedSubjects pero no en currentSubjects)
      const subjectsToAdd = selectedSubjects.filter(
        (subject) => !currentSubjects.includes(subject)
      );

      // Asignaturas que se van a remover (están en currentSubjects pero no en selectedSubjects)
      const subjectsToRemove = currentSubjects.filter(
        (subject) => !selectedSubjects.includes(subject)
      );
      this.addSubjectsToCompetence(competence.id, subjectsToAdd);
      this.removeSubjectsFromCompetence(competence.id, subjectsToRemove);
      toast(
        `${this.$getVisibleNames(
          "mesh.competence",
          false,
          "Competencia"
        )} ${this.$t("matrix3.matrix3View.updated")}`
      );
    },
    addSubjectsToCompetence(competence_id, matters_ids) {
      this.egressProfileMatterList
        .filter((x) => matters_ids.includes(x.id))
        .forEach((matter) => {
          let competences = [...matter.competences];
          competences.push(competence_id);
          let payload = {
            egress_profile_matter_id: matter.id,
            item: {
              competences: competences,
            },
          };
          this.$store.dispatch(names.PATCH_EGRESS_PROFILE_MATTER, payload);
        });
    },
    removeSubjectsFromCompetence(competence_id, matters_ids) {
      this.egressProfileMatterList
        .filter((x) => matters_ids.includes(x.id))
        .forEach((matter) => {
          let competences = [
            ...matter.competences.filter((x) => competence_id != x),
          ];
          let payload = {
            egress_profile_matter_id: matter.id,
            item: {
              competences: competences,
            },
          };
          this.$store.dispatch(names.PATCH_EGRESS_PROFILE_MATTER, payload);
        });
    },
    clearModalSelectionData(competence_id) {
      // Limpia los datos de selección del modal cuando se cierra
      this.$set(this.selectedSubjects, competence_id, []);
    },
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_PRINT_ORIENTATION);
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
    this.$store.commit(names.MUTATE_PRINT_ORIENTATION, true);
  },
  created() {
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    this.$store.dispatch(names.FETCH_CYCLES);
    // .then((response) => {
    //   if (response.length > 0) this.cycle_id = response[0].id;
    // });
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((egress_profile) => {
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$getVisibleNames("manual.matriz_3", false, "Matriz 3")} - ${
            egress_profile.name
          }`
        );
        this.$store.dispatch(names.FETCH_CAREER, egress_profile.career);
      });
    this.$store.dispatch(names.FETCH_COMPETENCE_TYPES, this.institution_id);
    this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COMPETENCES, this.egress_profile_id);
    this.$store.dispatch(names.FETCH_STUDY_UNITS_BY_CICLE_AND_PROFILE, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES_MENTION, {
      egress_profile_id: this.egress_profile_id,
    });
  },
};
</script>

<style scoped>
table {
  margin-bottom: 0.5rem;
}
.amount-courses {
  width: 10%;
}
.matrix3-report-container {
  padding: 0.2rem !important;
  page-break-before: auto !important;
  page-break-after: auto !important;
  page-break-inside: avoid !important;
}
.title {
  text-align: center;
  margin-bottom: 1rem;
}
.competences,
.institution-competences {
  border-bottom: 1px solid var(--kl-border-soft);
  margin-bottom: 0.1rem;
  padding-left: 0.5rem;
  padding: 0.6rem 0;
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
}
.institution-competences {
  margin-top: 0.9rem;
}
.competences-table,
.institution-competences-table {
  border: 1px solid var(--kl-table-border);
  width: 100%;
}
.competence-container {
  border-bottom: 1px solid var(--kl-table-border);
  border-right: 1px solid var(--kl-table-border);
  border-left: 1px solid var(--kl-table-border);
  border-radius: 10px;
  padding-bottom: 0.1rem;
  margin-top: 1.5rem;
  box-shadow: var(--kl-shadow-sm);
}
.competence-header {
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
}
.competence-caption,
.competence-caption-title {
  padding-right: 1rem;
  padding-left: 1rem;
  width: fit-content;
  text-align: left;
}
.competence-caption {
  padding: 0.4rem 1rem;
}
.competence-courses {
  text-align: center;
  padding-right: 2rem;
}
.amount {
  padding: 0 1rem;
}
.competences-row {
  padding-left: 0.2rem;
}
.competences-row:nth-child(odd) {
  background-color: var(--kl-surface-muted);
}
.competence-matters-div {
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  margin: 0.1em 0.1em;
  padding: var(--kl-chip-padding);
  border-radius: var(--kl-radius-pill);
  flex-grow: 1;
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
  max-width: fit-content;
}
.competence-matters-container {
  display: flex;
  flex-direction: row;
  justify-content: center !important;
  flex-wrap: wrap;
  margin: 0.8em 0;
}
.less-competence-matters-div {
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  margin: 0.1em 0.1em;
  padding: 4px 8px;
  border-radius: var(--kl-radius-pill);
  flex-grow: 1;
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-chip-fw);
  text-align: center;
  max-width: fit-content;
}
.profiles-container {
  width: 100%;
}
.profiles {
  background-color: var(--secondary-color);
  border-radius: 4px;
  padding: 0 2em;
  width: 100%;
  font-size: 11pt;
  text-align: center;
}
.text-white {
  text-align: left !important;
}
.th-class {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  vertical-align: middle !important;
  text-align: center !important;
}
.popover-btn .badge {
  border: none !important;
}
.realization-scopes-column {
  white-space: nowrap;
}
.realization-scope-number {
  display: inline-block;
  min-width: 1.6em;
  margin: 1px;
  padding: 0 0.3em;
  border-radius: var(--kl-radius-pill);
  background-color: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  font-size: var(--secondary-font-size);
  text-align: center;
  cursor: default;
}
</style>